import { cloneDeep } from 'lodash';
import axios from 'axios';
import Vue from 'vue';

export function parseTime(time, cFormat) {
    // 没有time或为null就返回
    if (arguments.length === 0 || !time) {
        return null;
    }
    const format = cFormat || '_{y}{m}{d}{h}{i}{s}';
    let date;
    if (typeof time === 'object') {
        date = time;
    } else {
        if (('' + time).length === 10) time = parseInt(time) * 1000;
        date = new Date(time);
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
    };
    const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key];
        if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1];
        if (result.length > 0 && value < 10) {
            value = '0' + value;
        }
        return value || 0;
    });
    return time_str;
}
// 把数字每三位加逗号
export function makeThree(nStr) {
    nStr += '';
    let x = nStr.split('.');
    let x1 = x[0];
    let x2 = x.length > 1 ? '.' + x[1] : '';
    let rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
}
// 日期格式为 xxxx-xx-xx
export function data_format(longtime) {
    const add0 = function (m) {
        return m < 10 ? '0' + m : m;
    };
    // 时间戳是整数，否则要parseInt转换
    const longtimeint = parseInt(longtime);
    const time = new Date(longtimeint);
    const y = time.getFullYear();
    const m = time.getMonth() + 1;
    const d = time.getDate();
    // const h = time.getHours();
    // const mm = time.getMinutes();
    // const s = time.getSeconds();
    return y + '-' + add0(m) + '-' + add0(d);
}
/**
 * 获取上一个月
 *
 * @date 格式为yyyy-mm-dd的日期，如：2014-01-25  getNextMonth(data_format(new Date().getTime())
 */
export function getPreMonth(date) {
    var arr = date.split('-');
    var year = arr[0]; //获取当前日期的年份
    var month = arr[1]; //获取当前日期的月份
    var day = arr[2]; //获取当前日期的日
    // var days = new Date(year, month, 0);
    // days = days.getDate(); //获取当前日期中月的天数
    var year2 = year;
    var month2 = parseInt(month) - 1;
    if (month2 == 0) {
        year2 = parseInt(year2) - 1;
        month2 = 12;
    }
    var day2 = day;
    var days2 = new Date(year2, month2, 0);
    days2 = days2.getDate();
    if (day2 > days2) {
        day2 = days2;
    }
    if (month2 < 10) {
        month2 = '0' + month2;
    }
    var t2 = year2 + '-' + month2 + '-' + day2;
    return t2;
}
// 日期格式为 xxxx-xx-xx hh:ss
export function dataFormat(longtime) {
    const add0 = function (m) {
        return m < 10 ? '0' + m : m;
    };
    // 时间戳是整数，否则要parseInt转换
    const longtimeint = parseInt(longtime);
    const time = new Date(longtimeint);
    const y = time.getFullYear();
    const m = time.getMonth() + 1;
    const d = time.getDate();
    const h = time.getHours();
    // const mm = time.getMinutes();
    const s = time.getSeconds();
    return y + '-' + add0(m) + '-' + add0(d) + '  ' + add0(h) + ':' + add0(s);
}
export function formatTime(time, option) {
    time = +time * 1000;
    const d = new Date(time);
    const now = Date.now();

    const diff = (now - d) / 1000;

    if (diff < 30) {
        return '刚刚';
    } else if (diff < 3600) {
        // less 1 hour
        return Math.ceil(diff / 60) + '分钟前';
    } else if (diff < 3600 * 24) {
        return Math.ceil(diff / 3600) + '小时前';
    } else if (diff < 3600 * 24 * 2) {
        return '1天前';
    }
    if (option) {
        return parseTime(time, option);
    } else {
        return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分';
    }
}

// 根据和求数组的子集
export function getSubArrayBySum(arr, sum) {
    //给定一个含有n个元素的整形数组，再给定一个和sum，求出数组中满足给定和的所有元素组合

    /**
     * arr : 目标数组
     * sum : 给定的和
     * res : 结果数组
     * c : 符合条件的数组子集
     * n : 数组长度
     * t : 当前子集存储的元素个数
     */
    // var arr = [5, 2, 3, 4, 11, 6, 7, 8, 9];
    var res = [];
    var c = [];
    // var sum = 10;

    function fixedSum(arr, n, t, sum) {
        if (sum === 0) {
            res.push(c.slice(0));
        } else {
            if (t === n) {
                return;
            } else {
                c.push(arr[t]);
                if (sum - arr[t] >= 0) {
                    fixedSum(arr, n, t + 1, sum - arr[t]);
                }
                c.pop();
                if (sum >= 0) {
                    fixedSum(arr, n, t + 1, sum);
                }
            }
        }
    }

    fixedSum(arr, arr.length, 0, sum);
    // console.log(res);
    return res;
}

// 取数组所有数的和
export function getArraySum(array) {
    var sum = 0;
    array.forEach(function (val) {
        sum += val;
    });
    return sum;
}

export function deepClone(obj) {
    let temp = obj.constructor === Array ? [] : {};
    for (let val in obj) {
        temp[val] = typeof obj[val] == 'object' ? deepClone(obj[val]) : obj[val];
    }
    return temp;
}
export function getToFixed(number, m) {
    let convertNum = Number(number);
    if (Number.isNaN(convertNum)) {
        // throw new Error(getToFiexed.name + '参数number必须为数字')
        return number;
    }
    const reg = /((\.\d*[1-9])(0+$))|(\.0+$)/;
    convertNum = convertNum.toFixed(m);
    return Number(convertNum.replace(reg, '$2'));
}

export function get_random_color() {
    const r = parseInt(Math.random() * 255);
    const g = parseInt(Math.random() * 255);
    const b = parseInt(Math.random() * 255);
    return `rgb(${r},${g},${b})`;
}

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
    return /^(https?:|mailto:|tel:)/.test(path);
}

export function debounce(func, wait = 200, immediate = true) {
    let timer = null;
    return function (...params) {
        clearTimeout(timer);
        let now = immediate && !timer;
        timer = setTimeout(() => {
            timer = null;
            !immediate ? func.call(this, ...params) : null;
        }, wait);
        now ? func.call(this, ...params) : null;
    };
}
/**
 *
 * @param {*} tree 树形数组
 * @param {*} key children的属性,默认为children
 * @param {*} pid 为扁平化array添加上parentId的标记
 * @returns
 */
export function treeToList(tree, key = 'children', pid) {
    const cloneTree = cloneDeep(tree);
    var queen = [];
    var result = [];
    queen = queen.concat(cloneTree);
    while (queen.length) {
        var first = queen.shift();
        if (first[key]) {
            typeof pid !== 'undefined' &&
                first[key].forEach((item) => {
                    item.parentId = first[pid];
                });
            queen = queen.concat(first[key]);
            delete first[key];
        }

        result.push(first);
    }
    return result;
}

/**
 * 寻找number数组中最接近目标数值的值
 * @param {*} arr number 数组
 * @param {*} num number数值
 * @returns
 */
export function findCloseNum(arr, num) {
    var index = 0; // 保存最接近数值在数组中的索引
    var old_value = Number.MAX_VALUE; // 保存差值绝对值，默认为最大数值
    for (var i = 0; i < arr.length; i++) {
        var new_value = Math.abs(arr[i] - num); // 新差值
        if (new_value <= old_value) {
            // 如果新差值绝对值小于等于旧差值绝对值，保存新差值绝对值和索引
            if (new_value === old_value && arr[i] < arr[index]) {
                // 如果数组中两个数值跟目标数值差值一样，取大
                continue;
            }
            index = i;
            old_value = new_value;
        }
    }
    return arr[index]; // 返回最接近的数值
}

// 检查用户本地版本号，有新版本需要用户重新登录
export function isNewVersion() {
    const url = `//${window.location.host}/static/version.json?t=${new Date().getTime()}`;
    // 弹窗单例化
    const resetNotify = () => {
        //关闭上一个弹窗，继续下一个弹窗
        if (Vue.prototype.globalInstance) {
            return;
        }
        // Vue.prototype.globalInstance = MessageBox.alert('检测到版本更新，即将刷新页面。', '提示', {
        //     confirmButtonText: '确定',
        //     callback: async () => {
        //         localStorage.setItem('saasVersion', saasVersion);
        //         Vue.prototype.globalInstance = null;
        //         await store.dispatch('user/fedLogOut');
        //         router.push({ path: '/login' });
        //         window.location.reload(true);
        //     }
        // });
    };
    axios.get(url).then((res) => {
        if (res.status === 200) {
            const saasVersion = res.data.version;
            const localSaasVersion = localStorage.getItem('saasVersion');
            if (localSaasVersion && localSaasVersion != saasVersion) {
                resetNotify(saasVersion);
                return;
            } else {
                localStorage.setItem('saasVersion', saasVersion);
            }
        }
    });
}

function resolvePath(...paths) {
    let i = paths.length;

    while (--i) {
        if (/^\//.test(paths[i])) break;
    }

    return paths
        .slice(i)
        .join('/') // 加入 '/'
        .replace('//', '/'); // 替换可能存在的 '//'
}
//将router相对路径转为绝对路径
export function restructure(routes = [], base = '/') {
    return routes.map((route) => {
        let { path, children = [] } = route;

        path = resolvePath(base, path);

        if (children.length > 0) {
            route.children = restructure(children, path);
        }

        return {
            ...route,
            path
        };
    });
}
export function getURLParameter(name) {
    // 获取查询字符串部分
    var searchString = window.location.search.substring(1);
    // 将查询字符串分割成参数对
    var params = searchString.split('&');
    // 遍历参数对，找到匹配的参数
    for (var i = 0; i < params.length; i++) {
        var pair = params[i].split('=');
        if (pair[0] === name) {
            // 返回参数值
            return decodeURIComponent(pair[1]);
        }
    }
    // 如果没有找到匹配的参数，返回null
    return null;
}
//时间戳转换 年月日
export function timeChange(timestamp) {
    if (timestamp) {
        // 将时间戳转换为毫秒
        const date = new Date(timestamp);
        // 获取年、月、日
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从 0 开始，因此需要加 1
        const day = String(date.getDate()).padStart(2, '0');
        // 格式化日期为 年-月-日
        return `${year}-${month}-${day}`;
    } else {
        return '';
    }
}
